import React from 'react';
import type { Page, Component } from '../../ComponentEditModal.types';
import type { CountdownTimerData } from './types';
import { HeadlinesSection } from './HeadlinesSection';
import { BackgroundSection } from './BackgroundSection';
import { TimerSettingsSection } from './TimerSettingsSection';
import { ExpirationSection } from './ExpirationSection';
import { ColorSection } from './ColorSection';
import { ButtonsEditor } from '../../shared/ButtonsEditor';

interface CountdownTimerEditorProps {
  formData: CountdownTimerData;
  setFormData: (data: CountdownTimerData) => void;
  pages: Page[];
  isLoadingPages: boolean;
  onOpenMediaUpload: (mediaType: 'image' | 'video', assetType: string) => void;
  currentPageComponents?: Component[];
}

export const CountdownTimerEditor: React.FC<CountdownTimerEditorProps> = ({
  formData,
  setFormData,
  pages,
  isLoadingPages,
  onOpenMediaUpload,
  currentPageComponents,
}) => {
  const data = formData || {};
  const buttons = data.buttons || [];

  return (
    <div className="space-y-6">
      <HeadlinesSection data={data} setFormData={setFormData} />
      <BackgroundSection
        data={data}
        setFormData={setFormData}
        onOpenMediaUpload={onOpenMediaUpload}
      />
      <TimerSettingsSection data={data} setFormData={setFormData} />
      <ExpirationSection data={data} setFormData={setFormData} />

      {/* Call-to-Action Buttons */}
      <ButtonsEditor
        buttons={buttons}
        onChange={newButtons => setFormData({ ...data, buttons: newButtons })}
        pages={pages}
        isLoadingPages={isLoadingPages}
        currentPageComponents={currentPageComponents}
        label="Call-to-Action Buttons (Optional)"
      />

      <ColorSection data={data} setFormData={setFormData} />
    </div>
  );
};

export default CountdownTimerEditor;
